<template>
  <div>
    <el-button
      type="primary"
      size="small"
      icon="el-icon-plus"
      v-permission="Auth.productGroupNew"
      @click="handleAdd()"
      >添加仪器串</el-button
    >
    <el-table :data="items.list" size="small" class="mt-10" v-loading="loading">
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="组建日期">
        <template slot-scope="scope">
          {{ $time(scope.row.created_at).format('YYYY-MM-DD') }}
        </template>
      </el-table-column>
      <el-table-column label="包含仪器">
        <template slot-scope="scope">
          <div style="display: flex; gap: 5px; flex-wrap: wrap">
            <el-tag
              size="mini"
              v-for="item in scope.row.product_names.split(',')"
              :key="item"
              >{{ item }}</el-tag
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="趟钻数" prop="usage" align="center">
        <template slot-scope="scope"> 第{{ scope.row.usage }}趟 </template>
      </el-table-column>
      <!-- <el-table-column
        label="使用时长"
        prop="used_hour"
        align="center"
      ></el-table-column>
      <el-table-column label="起钻原因" prop="up_reason"></el-table-column>
      <el-table-column label="故障描述" prop="malfunction"></el-table-column> -->
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-popconfirm
            v-permission="Auth.productGroupDelete"
            title="确认删除该仪器串吗？"
            @confirm="hanldeDelte(scope.row, scope.$index)"
          >
            <el-button
              slot="reference"
              type="text"
              size="small"
              class="text-danger"
              >删除</el-button
            >
          </el-popconfirm>
          <el-button
            type="text"
            size="small"
            class="ml-5"
            v-permission="Auth.productGroupNew"
            @click="handleAdd(scope.row)"
            >复制</el-button
          >
          <el-button
            type="text"
            size="small"
            class="ml-5"
            v-permission="Auth.productGroupEdit"
            @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="small"
            class="ml-5"
            v-permission="Auth.productGroupAddRecord"
            @click="$emit('select', scope.row.id)"
            >添加使用记录</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="mt-20"
      :page-size="filter.size"
      :current-page.sync="filter.page"
      @current-change="getData(false)"
      layout="total, prev, pager, next"
      :total="items.count"
    ></el-pagination>
    <Former
      :model="model"
      :show.sync="dialogVisible"
      @created="createdCallback"
      @updated="updatedCallback"
    ></Former>
  </div>
</template>

<script>
import { productGroupList, productGroupDelete } from '@/service/getData'
import Former from './former.vue'
export default {
  components: {
    Former,
  },
  props: {
    wellid: Number,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      data.drill_well_id = this.wellid
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        page: 1,
        size: 10,
      },
      items: {
        list: [],
        count: 0,
      },
      model: {},
      dialogVisible: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
      }

      this.loading = true
      let res = await productGroupList(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },

    createdCallback(data) {
      this.items.list.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.items.list, this.editIndex, data)
    },
    handleAdd(item = {}) {
      this.model = {
        name: item.name || '',
        copy_add: item.id > 0,
        drill_well_id: this.wellid,
        usage: item.usage || '',
        used_hour: item.used_hour || 0,
        up_reason: item.up_reason || '',
        malfunction: item.malfunction || '',
        product_ids: item.product_ids || [],
        remark: '',
      }
      this.dialogVisible = true
    },
    handleEdit(index, item) {
      this.model = this.clone(item)
      this.editIndex = index
      this.dialogVisible = true
    },
    async hanldeDelte(item, index) {
      let res = await productGroupDelete(item.id)
      if (res.code == 0) {
        this.items.list.splice(index, 1)
      }
    },
  },
}
</script>
